import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist'
import axios from 'axios'
import VuexORM from '@vuex-orm/core'
import VuexORMAxios from '@vuex-orm/plugin-axios'

import {AnnouncementModule} from '@/modules/Announcement';
import {MentorModule} from '@/modules/MentorModule';
import {GroupsModule} from '@/modules/GroupsModule';
import {AuthModule} from '@/modules/AuthModule';
import {DocumentStore} from '@/stores/DocumentStore';
import {GuardianModule} from '@/modules/GuardianModule';
import {ForumModule} from '@/modules/ForumModule';
import {UrlModule} from '@/modules/UrlModule';
import {LoaderModule} from '@/modules/LoaderModule';
import {ChatModule} from '@/modules/ChatModule';
import {SidebarStore} from '@/stores/SidebarStore';
import {ProcessModule} from '@/modules/ProcessModule';
import {JournalModule} from '@/modules/JournalModule';
import {SearchModule} from '@/modules/SearchModule'
import {LastLessonModule} from '@/modules/LastLessonModule'
import {YearsModule} from '@/modules/Years';
import {App} from '@/modules/App'

import Announcement from "@/models/lms/Announcement";
import AnnouncementModel from "@/models/lms/AnnouncementModel";
import Answer from "@/models/lms/Answer";
import Board from '@/models/lms/Board'
import BoardUser from '@/models/lms/BoardUser'
import CalendarEvent from "@/models/sis/CalendarEvent";
import Comment from '@/models/lms/Comment'
import Course from "@/models/lms/Course";
import ClassGroup from "@/models/sis/ClassGroup";
import EventType from "@/models/sis/EventType";
import Folder from "@/models/sis/Folder";
import Group from "@/models/lms/Group";
import Lesson from "@/models/lms/Lesson";
import LessonNote from "@/models/lms/LessonNote";
import LMSForum from "@/models/lms/LMSForum";
import LMSForumTopic from "@/models/lms/LMSForumTopic";
import LMSForumPost from "@/models/lms/LMSForumPost";
import LMSForumComment from "@/models/lms/LMSForumComment";
import LMSForumSubComment from "@/models/lms/LMSForumSubComment";
import UserLessonNote from "@/models/lms/UserLessonNote";
import Media from '@/models/lms/Media'
import Module from "@/models/lms/Module";
import ModuleLesson from "@/models/lms/ModuleLesson";
import ModuleQuiz from "@/models/lms/ModuleQuiz";
import Note from '@/models/lms/Note'
import Question from "@/models/lms/Question";
import Quiz from "@/models/lms/Quiz";
import LMSUser from '@/models/lms/User'
import UserAnswer from "@/models/lms/UserAnswer";
import UserPermission from "@/models/lms/UserPermission";
import SISMedia from '@/models/sis/Media'
import Subject from '@/models/sis/Subject'
import {CalendarModule} from "@/modules/Calendar";
import {LessonModule} from "@/modules/Lesson";
import {LessonNoteModule} from "@/modules/LessonNoteModule";
import {SizeModule} from "@/modules/Size";
import {ToastModule} from "@/modules/Toast";
import {UserModule} from "@/modules/User";
import {TenantModule} from "@/modules/TenantModule";
import Assessment from "@/models/sis/Assessment";
import AssessmentFeedback from "@/models/sis/AssessmentFeedback";
import AssessmentSubmission from "@/models/sis/AssessmentSubmission";
import Campus from "@/models/sis/Campus";
import Enrolment from "@/models/sis/Enrolment";
import JournalEntry from "@/models/sis/JournalEntry";
import JournalFeedback from "@/models/sis/JournalFeedback";
import Term from "@/models/sis/Term";
import SISUser from "@/models/sis/User";
import CalendarEventAudience from "@/models/sis/CalendarEventAudience";
import Alert from "@/models/sis/Alert";
import AlertAudience from "@/models/sis/AlertAudience";
import {LMSAssessment} from "@/models/lms/LMSAssessment";
import {LMSAssessmentQuestion} from "@/models/lms/LMSAssessmentQuestion";
import {LMSAssessmentUser} from "@/models/lms/LMSAssessmentUser";
import FileType from "@/models/sis/FileType";
import CourseModule from "@/models/lms-central/CourseModule";
import ModuleEntity from "@/models/lms-central/ModuleEntity";
import Grade from "@/models/sis/Grade";
import SISAnnouncements from "@/models/sis/SISAnnouncement";
import SISAnnouncementModel from "@/models/sis/SISAnnouncementModel";
import {CometChatModule} from "@/modules/CometChatModule";
import Notification from "@/models/lms/Notification";
import Activity from "@/models/sis/Activity";
import LessonPlan from "@/models/sis/LessonPlan";
import SISLesson from "@/models/sis/SISLesson";
import Objective from "@/models/sis/Objective";
import CourseScope from "@/models/sis/CourseScope";
import CustomYear from "@/models/sis/CustomYear";


const database = new VuexORM.Database()
database.register(Alert)
database.register(AlertAudience)
database.register(Announcement)
database.register(AnnouncementModel)
database.register(Answer)
database.register(Board)
database.register(BoardUser)
database.register(CalendarEvent)
database.register(CalendarEventAudience)
database.register(Comment)
database.register(Course)
database.register(EventType)
database.register(Folder)
database.register(Group)
database.register(Lesson)
database.register(LessonNote)
database.register(LMSForum)
database.register(LMSForumTopic)
database.register(LMSForumPost)
database.register(LMSForumComment)
database.register(LMSForumSubComment)
database.register(UserLessonNote)
database.register(Media)
database.register(Module)
database.register(ModuleLesson)
database.register(ModuleQuiz)
database.register(Note)
database.register(Question)
database.register(Quiz)
database.register(LMSUser)
database.register(UserAnswer)
database.register(UserPermission)
database.register(SISMedia)
database.register(Assessment)
database.register(AssessmentFeedback)
database.register(AssessmentSubmission)
database.register(Campus)
database.register(Enrolment)
database.register(JournalEntry)
database.register(JournalFeedback)
database.register(Subject)
database.register(Term)
database.register(SISUser)
database.register(ClassGroup)
database.register(LMSAssessment)
database.register(LMSAssessmentQuestion)
database.register(LMSAssessmentUser)
database.register(FileType)
database.register(CourseModule)
database.register(ModuleEntity)
database.register(SISAnnouncements)
database.register(SISAnnouncementModel)
database.register(Grade)
database.register(Notification)
database.register(Activity)
database.register(LessonPlan)
database.register(SISLesson)
database.register(Objective)
database.register(CourseScope)
database.register(CustomYear)

Vue.use(Vuex)
VuexORM.use(VuexORMAxios, {axios})
const vuexAuth = new VuexPersistence({
    modules: []
})

export default new Vuex.Store({
    modules: {
        tenant: TenantModule,
        announcements: AnnouncementModule,
        auth: AuthModule,
        url: UrlModule,
        loader: LoaderModule,
        documentStore: DocumentStore,
        forum: ForumModule,
        mentor: MentorModule,
        groups: GroupsModule,
        chat: ChatModule,
        sidebar: SidebarStore,
        process: ProcessModule,
        calendar: CalendarModule,
        guardian: GuardianModule,
        journal: JournalModule,
        search: SearchModule,
        lastLesson: LastLessonModule,
        lessonNotes: LessonNoteModule,
        size: SizeModule,
        toast: ToastModule,
        lesson: LessonModule,
        user: UserModule,
        app: App,
        cometChat: CometChatModule,
        Years: YearsModule
    },
    plugins: [vuexAuth.plugin, VuexORM.install(database)]


});
